// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"fZ-z","sponsoredTooltipWrapper":"gZ-z","sponsoredTooltip":"hZ-z","newCard":"iZ-z"};